export default {
    repaymentFirst: '请完成还款后进行提现',
    repaymentCode: "支付码",
    checkRepaymentCode: "查看支付码",
    upAmount: "按时还款可重复借款，并且金额递增",
};
